import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '../../../js/AppState';
import classes from './Footer.module.css';

import Texts from 'react-sdk/Texts';




const Footer = ({showCredits = true}) => {
  function handleMentionsClick(e) {
    e.preventDefault()
    PopupsManager.open(POPUPS.MENTIONS_LEGALES)
  }
  // function handleCreditsClick(e) {
  //   e.preventDefault()
  //   PopupsManager.open(POPUPS.CREDITS)
  // }
  let mentions_link = Texts.get("mentions-legales-link", {fallback: null})
  // let credits_link = Texts.get("credits-link", {fallback: null})

  return (
   <footer className={classes.Footer}>
    <div className={classes.footer_left}>

      <a target="_blank" href="https://astekgroup.fr">
        <img src="data/images/logos/logo_astek.png" alt="Logo Astek" />
      </a>
      <img src="data/images/logos/logo_meh.png" alt="Logo MEH" />

    </div>

    <div className={classes.footer_center}>
      {mentions_link &&
      <a target="_blank" onClick={handleMentionsClick} href="#">{mentions_link}</a>}
    </div>
    <div className={classes.footer_right}>
      <a target="_blank" href="https://www.lbdeveloppement.com">
        <img src="data/images/logos/logo_lb.png" alt="Logo LB" />
      </a>
      <div className={classes.ludicius_tagline}>
        <img src="data/images/logos/logo_ludicius.png" alt="" />
        Made with fun by <a href="https://ludicius.com">Ludicius</a>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
